import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8aadfd04")

_pushScopeId("data-v-8aadfd04")
const _hoisted_1 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SelectedHospital = _resolveComponent("SelectedHospital")
  const _directive_RRN = _resolveDirective("RRN")

  return (!_ctx.state.isLoading)
    ? (_openBlock(), _createBlock("main", _hoisted_1, [
        _withDirectives(_createVNode("section", {
          class: _ctx.isType ? 'main__section mode' : 'main__section'
        }, [
          (_ctx.state.selectHospital !== 0 && !_ctx.state.selectHospital)
            ? (_openBlock(), _createBlock(_component_SelectedHospital, {
                key: 0,
                onSelected: _cache[1] || (_cache[1] = (key)=>_ctx.state.selectHospital = key )
              }))
            : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.onlineCareRequest), {
                key: 1,
                hospitalKey: _ctx.state.selectHospital,
                hcode: _ctx.hcode,
                dcode: _ctx.dcode
              }, null, 8, ["hospitalKey", "hcode", "dcode"]))
        ], 2), [
          [_directive_RRN]
        ])
      ]))
    : _createCommentVNode("", true)
})